import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ImpressumProps {
  isOpen: boolean;
  onClose: () => void;
}

const Impressum: React.FC<ImpressumProps> = ({ isOpen, onClose }) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[9999] p-4" onClick={onClose}>
      <div 
        className="relative bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
        onClick={e => e.stopPropagation()}
        style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">
              {t('impressum.title')}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
              aria-label={t('impressum.close')}
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>
          
          <div className="space-y-6 text-gray-700 dark:text-gray-300">
            <div>
              <h3 className="text-lg font-semibold mb-2 text-indigo-600 dark:text-indigo-400">
                {t('impressum.responsible')}
              </h3>
              <p>Matthias Bauer</p>
              <p>Dessauer Str. 20</p>
              <p>39261 Zerbst</p>
              <p>Deutschland</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2 text-indigo-600 dark:text-indigo-400">
                {t('impressum.contact')}
              </h3>
              <p>E-Mail: kontakt@matthiasbauer.dev</p>
              {/*<p>Telefon: +49 123 4567890</p>*/}
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2 text-indigo-600 dark:text-indigo-400">
                {t('impressum.disclaimer.title')}
              </h3>
              <p className="mb-2">{t('impressum.disclaimer.content')}</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-2 text-indigo-600 dark:text-indigo-400">
                {t('impressum.privacy')}
              </h3>
              <p>{t('impressum.privacyText')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;